<template>

  <section class="table users">
    <UsersHeader
      :column-sorted-by="columnSortedBy"
      :sort-by-ascending="sortByAscending"
      @sort-by-column="sortByColumn"
    />

    <div
      class="row"
      :class="{ 'not-working': user.notWorking, 'highlighted': isHighlighted(user.key) }"
      v-if="showBrokeUsers || !user.notWorking"
      v-for="user in filteredUsers"
      :key="user.key"
    >
      <div class="column loginId">
        <div
          :id="'loginId' + user.key"
          @click="copyToClipboard('loginId' + user.key)"
        >
          {{user.loginId}}
        </div>
        <div
          v-if="user.notes && user.notes.length > 0"
          class="note-icon-container"
          @click="displayNote('notes' + user.key)"
        >
          <Note />
        </div>
      </div>
      <div
        class="column password"
        :id="'password' + user.key"
        @click="copyToClipboard('password' + user.key)"
      >
        <div>{{user.password}}</div>
      </div>
      <div
        class="column password-icon"
        @click="copyToClipboard('password' + user.key)"
      >
        <Padlock />
      </div>
      <div
        class="column security-answer"
        :id="'securityAnswer' + user.key"
        @click="copyToClipboard('securityAnswer' + user.key)"
      >
        {{user.securityAnswer}}
      </div>
      <div
        class="column environment"
        :id="'environment' + user.key"
      >
      {{user.environment}}
      </div>
      <div
        class="column notes"
        :id="'notes' + user.key"
      >
        {{user.notes}}
      </div>
      <div
        class="column info"
        @click="displayUserForm(user, true)"
      >
        <Info />
      </div>
      <div class="actions">
        <span @click="displayUserForm(user, false)">
          <EditPencil />
        </span>
        <Highlighter
          @doToggleHighlight="toggleHighlight(user.key)"
          :class="{ 'active-highlight': isHighlighted(user.key) }"
        />
      </div>
    </div>

    <UserForm
      v-if="showUserForm"
      :selectedUser="user"
      :disableForm="disableUserForm"
      @hide-dialog="hideUserForm"
      @save-user="updateUser"
      @delete-user="deleteUser"
    />
    <Uprising
      :class="{ 'show': showUprising }"
      :data="data"
    />
  </section>
</template>

<script>
  import Uprising from '@/components/Uprising.vue'
  import EditPencil from '@/components/assets/EditPencil.vue'
  import Highlighter from '@/components/assets/Highlighter.vue'
  import Padlock from '@/components/assets/Padlock.vue';
  import Info from '@/components/assets/Info.vue';
  import Note from '@/components/assets/Note.vue';
  import UserForm from '@/components/user/UserForm.vue'
  import {sortBy} from '../../utilities/array.utilities';
  import UsersHeader from './UsersHeader';

  export default {
  name: 'Users',
  props: {
    users: {
      type: Array,
      required: true
    },
    showBrokeUsers: {
      type: Boolean,
      required: true
    },
    searchText: {
      type: String,
      default: ''
    }
  },
  components: {
    UsersHeader,
    Padlock,
    Info,
    EditPencil,
    Highlighter,
    Uprising,
    UserForm,
    Note
  },
  data() {
    return {
      data: '',
      showUprising: false,
      showUserForm: false,
      user: null,
      highlighted: [],
      columnSortedBy: {
        loginId: { display: true, ascending: true },
        password: { display: false, ascending: true },
        securityAnswer: { display: false, ascending: true },
        environment: { display: false, ascending: true },
        notes: { display: false, ascending: true }
      },
      sortByAscending: true,
      disableUserForm: false
    }
  },
  computed: {
    filteredUsers() {
      return this.users.filter((user) => {
        return user.loginId.toLowerCase().includes(this.searchText.toLowerCase())
      })
    }
  },
  methods: {
    copyToClipboard(id) {
      const elementValue = document.getElementById(id).innerText
      this.$copyText(elementValue)
        .then(() => {
          this.data = `${elementValue} was copied.`
          this.displayUprising()
        }, () => {
          alert('Unable to copy text')
        })
    },
    displayNote(id) {
      const elementValue = document.getElementById(id).innerText
      this.data = `Note: ${elementValue}`
      this.displayUprising()
    },
    displayUprising() {
      this.showUprising = true
      setTimeout(() => {
        this.showUprising = false
      }, 3500)
    },
    updateUser(user) {
      this.$store.dispatch('projects/updateUser', user)
        .then(() => this.showUserForm = false)
    },
    displayUserForm(user, isDisabled) {
      this.disableUserForm = isDisabled
      this.user = user
      this.showUserForm = true
    },
    hideUserForm() {
      this.showUserForm = false
    },
    deleteUser(user) {
      const confirm = window.confirm(`Are you sure you want to delete ${user.loginId}?`)
      if (confirm) {
        this.$store.dispatch('projects/deleteUser', user)
          .then(() => this.showUserForm = false)
      }
    },
    sortByColumn(columnName) {
      if (this.columnSortedBy[columnName].display) this.toggleSortByAscending()

      for (let prop in this.columnSortedBy) {
        this.columnSortedBy[prop].display = (prop === columnName);
      }

      this.users = sortBy(this.users, columnName, this.sortByAscending)
    },
    toggleSortByAscending() {
      this.sortByAscending = !this.sortByAscending
    },
    isChrome() {
      return !!window.chrome && !!window.chrome.webstore;
    },
    isHighlighted(key) {
      return this.highlighted.includes(key) ? true : false
    },
    toggleHighlight(key) {
      if(this.isHighlighted(key)) this.highlighted.splice( this.highlighted.indexOf(key));
      else this.highlighted.push(key);
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/tables';

.password-icon, .info {
  flex-basis: 15%;
  font-size: 0;
  @include flex(row, center, center);
}

.note-icon-container {
  margin-right: 10px;
}

.row div:not(.actions) {

  &.info, &.password-icon {
    padding: 0;
  }
}

@media (min-width: 600px) {
  &.password-icon, &.info, &.note-icon-container {
    display: none;
  }

  .password-icon {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/Users.vue